import { combineReducers } from '@reduxjs/toolkit';

import { IPLocationApi } from '_services/Api/IPLocation/IPLocationApi';
import { MembershipQueryApi } from '_services/Api/Membership/MembershipApi';
import { PatternLibraryApi } from '_services/Api/PatternLibrary/PatternLibraryApi';
import BaseApi from '_services/Api/_utils/BaseApi';
import FlashMessageReducer from './FlashMessage/FlashMessageSlice';
import { LayoutReducer } from './Layout/LayoutSlice';
import ToastReducer from './Toast/ToastSlice';
import UserReducer from './User/UserSlice';

const rootReducer = combineReducers({
    user: UserReducer,
    flash: FlashMessageReducer,
    layout: LayoutReducer,
    toast: ToastReducer,
    // with RTK queries
    [PatternLibraryApi.reducerPath]: PatternLibraryApi.reducer,
    [IPLocationApi.reducerPath]: IPLocationApi.reducer,
    [BaseApi.reducerPath]: BaseApi.reducer,
    [MembershipQueryApi.reducerPath]: MembershipQueryApi.reducer,
});

export const middleware = [
    PatternLibraryApi.middleware,
    IPLocationApi.middleware,
    BaseApi.middleware,
    MembershipQueryApi.middleware,
];

export default rootReducer;
